import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_recaptcha_07bfb1bf from 'nuxt_plugin_recaptcha_07bfb1bf' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_pluginsmediaQuery5bb68c08_98a53ad4 from 'nuxt_plugin_pluginsmediaQuery5bb68c08_98a53ad4' // Source: ./plugins.mediaQuery.5bb68c08.js (mode: 'all')
import nuxt_plugin_libplugin5cb112d8_6d58ecc2 from 'nuxt_plugin_libplugin5cb112d8_6d58ecc2' // Source: ./lib.plugin.5cb112d8.js (mode: 'all')
import nuxt_plugin_axios_0ba94b50 from 'nuxt_plugin_axios_0ba94b50' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_0535426e from 'nuxt_plugin_nuxtsvgsprite_0535426e' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_workbox_48542c6c from 'nuxt_plugin_workbox_48542c6c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_74bf7102 from 'nuxt_plugin_metaplugin_74bf7102' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_webvitalsclient_acb45e58 from 'nuxt_plugin_webvitalsclient_acb45e58' // Source: ../src/plugins/web-vitals.client.js (mode: 'client')
import nuxt_plugin_cookies_2c3cf8fe from 'nuxt_plugin_cookies_2c3cf8fe' // Source: ../src/plugins/cookies.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../src/plugins/axios.js (mode: 'all')
import nuxt_plugin_utils_1ea7651c from 'nuxt_plugin_utils_1ea7651c' // Source: ../src/plugins/utils.js (mode: 'all')
import nuxt_plugin_animodlink_3837918c from 'nuxt_plugin_animodlink_3837918c' // Source: ../src/plugins/animod-link.js (mode: 'all')
import nuxt_plugin_tooltipclient_6a09e96b from 'nuxt_plugin_tooltipclient_6a09e96b' // Source: ../src/plugins/tooltip.client.js (mode: 'client')
import nuxt_plugin_iconsvg_4f21d3b1 from 'nuxt_plugin_iconsvg_4f21d3b1' // Source: ../src/plugins/icon-svg.js (mode: 'all')
import nuxt_plugin_vuegalleryclient_76ec8f1a from 'nuxt_plugin_vuegalleryclient_76ec8f1a' // Source: ../src/plugins/vue-gallery.client.js (mode: 'client')
import nuxt_plugin_vuesocialsharing_216967be from 'nuxt_plugin_vuesocialsharing_216967be' // Source: ../src/plugins/vue-social-sharing.js (mode: 'all')
import nuxt_plugin_nuxtinitclient_9ebf707c from 'nuxt_plugin_nuxtinitclient_9ebf707c' // Source: ../src/plugins/nuxt-init.client.js (mode: 'client')
import nuxt_plugin_vuexi18n_27c9b674 from 'nuxt_plugin_vuexi18n_27c9b674' // Source: ../src/plugins/vuex-i18n.js (mode: 'all')
import nuxt_plugin_intersectionObserverclient_a474beda from 'nuxt_plugin_intersectionObserverclient_a474beda' // Source: ../src/plugins/intersectionObserver.client.js (mode: 'client')
import nuxt_plugin_svg4everybodyclient_e114df56 from 'nuxt_plugin_svg4everybodyclient_e114df56' // Source: ../src/plugins/svg4everybody.client.js (mode: 'client')
import nuxt_plugin_loggerclient_76cf32e4 from 'nuxt_plugin_loggerclient_76cf32e4' // Source: ../src/plugins/logger.client.js (mode: 'client')
import nuxt_plugin_pwaclient_936cae3c from 'nuxt_plugin_pwaclient_936cae3c' // Source: ../src/plugins/pwa.client.js (mode: 'client')
import nuxt_plugin_vuemeta_029c2f55 from 'nuxt_plugin_vuemeta_029c2f55' // Source: ../src/plugins/vue-meta.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"@animod\u002Fshop","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0"},{"hid":"description","name":"description","content":"Hotelgutscheine & Reisegutscheine für Deutschland und Europa | Ideal als Geschenk ✓ Über 20 Jahre Erfahrung ✓ Jetzt günstig buchen!"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico","hid":"favicon","sizes":"any"},{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Ficon.svg","hid":"icon-svg"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon.png","hid":"apple-touch-icon"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_recaptcha_07bfb1bf === 'function') {
    await nuxt_plugin_recaptcha_07bfb1bf(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsmediaQuery5bb68c08_98a53ad4 === 'function') {
    await nuxt_plugin_pluginsmediaQuery5bb68c08_98a53ad4(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin5cb112d8_6d58ecc2 === 'function') {
    await nuxt_plugin_libplugin5cb112d8_6d58ecc2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_0ba94b50 === 'function') {
    await nuxt_plugin_axios_0ba94b50(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_0535426e === 'function') {
    await nuxt_plugin_nuxtsvgsprite_0535426e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_48542c6c === 'function') {
    await nuxt_plugin_workbox_48542c6c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_74bf7102 === 'function') {
    await nuxt_plugin_metaplugin_74bf7102(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webvitalsclient_acb45e58 === 'function') {
    await nuxt_plugin_webvitalsclient_acb45e58(app.context, inject)
  }

  if (typeof nuxt_plugin_cookies_2c3cf8fe === 'function') {
    await nuxt_plugin_cookies_2c3cf8fe(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_1ea7651c === 'function') {
    await nuxt_plugin_utils_1ea7651c(app.context, inject)
  }

  if (typeof nuxt_plugin_animodlink_3837918c === 'function') {
    await nuxt_plugin_animodlink_3837918c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tooltipclient_6a09e96b === 'function') {
    await nuxt_plugin_tooltipclient_6a09e96b(app.context, inject)
  }

  if (typeof nuxt_plugin_iconsvg_4f21d3b1 === 'function') {
    await nuxt_plugin_iconsvg_4f21d3b1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegalleryclient_76ec8f1a === 'function') {
    await nuxt_plugin_vuegalleryclient_76ec8f1a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharing_216967be === 'function') {
    await nuxt_plugin_vuesocialsharing_216967be(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtinitclient_9ebf707c === 'function') {
    await nuxt_plugin_nuxtinitclient_9ebf707c(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexi18n_27c9b674 === 'function') {
    await nuxt_plugin_vuexi18n_27c9b674(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_intersectionObserverclient_a474beda === 'function') {
    await nuxt_plugin_intersectionObserverclient_a474beda(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_svg4everybodyclient_e114df56 === 'function') {
    await nuxt_plugin_svg4everybodyclient_e114df56(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_loggerclient_76cf32e4 === 'function') {
    await nuxt_plugin_loggerclient_76cf32e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pwaclient_936cae3c === 'function') {
    await nuxt_plugin_pwaclient_936cae3c(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemeta_029c2f55 === 'function') {
    await nuxt_plugin_vuemeta_029c2f55(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
